<template>
  <div class="container text-left">
    <div class="row mt-4">
      <div class="col text-center">
        <h5>Manage Blog</h5>
        <div class="float-right">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#createBlogPostModal"
            v-on:click="postToEdit = null"
          >
            Add Post
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <div class="row">
          <div class="col-auto pr-0 pt-1">
            <label>Filter Categories:</label>
          </div>
          <div class="col-auto">
            <select
              id="category"
              name="categoryPicker"
              class="form-control selectpicker"
              data-style="btn-outline-primary"
              multiple
              data-live-search="true"
              data-actions-box="true"
              data-selected-text-format="count"
              data-none-selected-text="All Categories"
              v-model="filterByCategory"
            >
              <option
                v-for="category in categories.slice().sort()"
                :key="category.Category_Id + 'category'"
                v-bind:value="category"
                >{{ category.Name }}</option
              >
            </select>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-auto pr-0 pt-1">
            <label>Search:</label>
          </div>
          <div class="col-auto">
            <input
              class="form-control form-control-sm"
              type="text"
              v-model="searchKeyword"
              placeholder="Search"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="my-3" style="height: 2px; background-color: gray;" />
    <masonry
      :cols="{ default: 4, 1000: 3, 800: 2, 500: 1 }"
      :gutter="{ default: '30px', 700: '15px' }"
    >
      <div
        class="card mb-4"
        v-for="post in filterPosts()"
        :key="post.Blog_Post_Id"
      >
        <div class="row" style="z-index: 2;">
          <div class="col">
            <i
              v-bind:class="{
                'bg-success': post.Approved,
                'bg-warning': !post.Approved
              }"
              class="material-icons d-block pointer"
              style="margin-bottom: -2rem;"
              v-on:click="editPost(post)"
            >
              edit
            </i>
          </div>
        </div>
        <img
          v-bind:src="post.Thumbnail_Picture"
          class="card-img-top"
          alt="img"
        />
        <div class="card-body" style="background-color: #FAFAFA">
          <h5 class="card-title">{{ post.Title }}</h5>
          <p class="card-text">{{ post.Summary }}</p>
        </div>
      </div>
    </masonry>
    <CreateBlogPostModal
      v-bind:PostToEdit="postToEdit"
      v-bind:Categories="categories"
      @updatedPost="postEdited"
      @addedPost="postAdded"
      @deletedPost="postDeleted"
      @approvedPost="postApproved"
      @createdCategory="categoryAdded"
    />
  </div>
</template>

<script>
import CreateBlogPostModal from "@/modals/Blog/CreateBlogPostModal.vue";
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      blogPosts: [],
      categories: [],
      postToEdit: null,
      filterByCategory: [],
      searchKeyword: ""
    };
  },
  components: {
    CreateBlogPostModal
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.blogPosts = await view.$getAllBlogPosts();
      view.$data.categories = await view.$getAllCategories();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    filterPosts() {
      var filteredPosts = this.blogPosts;
      if (this.filterByCategory.length > 0) {
        console.log(filteredPosts);
        filteredPosts = filteredPosts.filter(s =>
          this.filterByCategory.some(c =>
            s.Categories.map(sc => sc.Category_Id).includes(c.Category_Id)
          )
        );
      }
      if (this.searchKeyword != "") {
        var search = this.searchKeyword.toLowerCase();
        filteredPosts = filteredPosts.filter(
          s =>
            s.Title.toLowerCase().includes(search) ||
            s.Summary.toLowerCase().includes(search)
        );
      }
      return filteredPosts;
    },
    editPost(post) {
      this.postToEdit = post;
      $("#createBlogPostModal").modal("show");
    },
    postAdded(post) {
      this.blogPosts.push(post);
    },
    postEdited(editedPost) {
      var editingIndex = this.blogPosts.findIndex(
        o => o.Blog_Post_Id == editedPost.Blog_Post_Id
      );
      this.$set(this.blogPosts, editingIndex, editedPost);
    },
    postDeleted(postId) {
      var deletedIndex = this.blogPosts.findIndex(
        o => o.Blog_Post_Id == postId
      );
      this.blogPosts.splice(deletedIndex, 1);
    },
    postApproved(postId) {
      var approvedIndex = this.blogPosts.findIndex(
        o => o.Blog_Post_Id == postId
      );
      this.blogPosts[approvedIndex].Approved = true;
    },
    categoryAdded(newCategory) {
      console.log("categoryAdded");
      console.log(newCategory);
      this.categories.push(newCategory);
      $("#createBlogPostModal").modal("show");
    }
  }
};
</script>

<style>
.blogContainer {
  -moz-column-count: 3;
  -moz-column-gap: 10px;
  -webkit-column-count: 3;
  -webkit-column-gap: 10px;
  column-count: 3;
  column-gap: 10px;
  width: 100%;
}

.blogContainerInner {
  display: inline-block;
  width: 200px;
  height: auto;
}
</style>
